import { IRequiredEventArgs } from './chain.interface';

export class ValidationEvent implements IRequiredEventArgs {
    public required = false;
    public raise: null | any = null;

    constructor(r: any, isrequired: boolean) {
        this.raise = r;
        this.required = isrequired;
    }
}
